import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const ParallaxVideoProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

ParallaxVideoProduct.fragment = gql`
  fragment ParallaxVideoProduct on Product {
    ...on ParallaxVideoProduct {
      assets {
        edges {
          node {
            id
            state
            ...on PhotoAsset {
              image(size: "monitor") {
                url
                thumbUrl
                width
                height
                labels
                filenameIndex
              }
            }
            ...on UrlAsset {
              url
            }
          }
        }
      }
    }
  }
`

export default ParallaxVideoProduct
